<router-outlet></router-outlet>
<app-offline></app-offline>
<app-absolute-loader *ngIf="siteStore.loading()" [text]="siteStore.loadingDescription()" />
<!-- <app-customer-support-button></app-customer-support-button> -->
<app-support-chat-widget></app-support-chat-widget>
<app-support-chat-notice></app-support-chat-notice>

<app-qr-scanner
  *ngIf="siteStore.showQrScanner()"
  class="fixed top-0 left-0 z-50 w-full h-full"
></app-qr-scanner>

<app-toast></app-toast>

<!-- <span class="fixed bottom-0 text-xs font-bold right-1 opacity-80">v{{appVersion}}</span> -->

<app-update-pwa-button></app-update-pwa-button>
